import React from "react";
import Header from "./headerFooter/header";
import HomeFooter from "./homepage/homefooter";
import HomeProducts from "./homepage/producthome";
import InstagramFeed from './InstaFeed';
import LandingPageSlider from "./homepage/landingPage";
import AboutPage from "./homepage/About";
import BlogHome from "./homepage/blogHome";
import ClassPage2 from "./HandleClass/classPage2";
const Home=()=>{


    return(
        <div>
        <Header/>
       
        <LandingPageSlider/>
        <AboutPage/>
        <ClassPage2/>
        {/* <ClassList/> */}
        
        <BlogHome/>
        <HomeProducts/>
        <InstagramFeed/>
        <HomeFooter/>
        </div>
    );
   
} ;export default Home;

